import { AlertTriangle, RefreshCcw } from 'lucide-react';
import { Component, type ReactNode } from 'react';

import { strings } from '@/lib/strings';

type AppErrorBoundaryProps = {
  children: ReactNode;
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Unhandled app surface error', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="surface-panel flex min-h-[320px] items-center justify-center px-6 py-10 text-center">
          <div className="max-w-md">
            <div className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <h2 className="mt-5 text-2xl font-semibold text-foreground">{strings.topbar.unexpectedErrorTitle}</h2>
            <p className="mt-3 text-sm leading-7 text-muted-foreground">{strings.topbar.unexpectedErrorBody}</p>
            <button
              type="button"
              className="primary-pill-button mx-auto mt-6 rounded-full"
              onClick={() => window.location.reload()}
            >
              <RefreshCcw className="h-4 w-4" />
              {strings.topbar.unexpectedErrorRetry}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
